import React from 'react';
import HolofelineCalendar from './components/HolofelineCalendar';

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <HolofelineCalendar />
    </div>
  );
}

export default App;